import React from 'react'
import { Upload, Form, Icon, Input, Button, Row, Col, DatePicker } from 'antd';

export const ConsentFormStep1 = (props) => {

    if (props.currentStep !== 'Step 1') {
      return null
    }

    return(

        <div className="form-group">

            <Form.Item>
                {props.getFieldDecorator('siteID', {
                    initialValue: props.siteID,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'Please input site id'
                    }],
                })(
                    <Input
                        prefix={<Icon type="medicine-box" style={{color: '#FAFAFA'}}/>}
                        id="siteID"
                        name="siteID"
                        placeholder="Site ID"
                        autoFocus
                        allowClear
                        size="large"
                    />
                )}
            </Form.Item>

            <Form.Item>
                {props.getFieldDecorator('userID', {
                    initialValue: props.userID,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'Please input user id'
                    }],
                })(
                    <Input
                        prefix={<Icon type="skin" style={{color: '#FAFAFA'}}/>}
                        id="userID"
                        name="userID"
                        placeholder="User ID"
                        allowClear
                        size="large"
                    />
                )}
            </Form.Item>

            <Form.Item>
                {props.getFieldDecorator('subjectID', {
                    initialValue: props.subjectID,
                    onChange: props.handleChange,
                    rules: [{
                        required: true,
                        message: 'Please input subject id'
                    }],
                })(
                    <Input
                        prefix={<Icon type="user" style={{color: '#FAFAFA'}}/>}
                        id="subjectID"
                        name="subjectID"
                        placeholder="Subject ID"
                        allowClear
                        size="large"
                    />
                )}
            </Form.Item>

       </div>

    );
}


// WEBPACK FOOTER //
// ./src/components/ConsentTypeRedDeerCalgary/Step1.js